import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=260ef89c&scoped=true"
import script from "./orderItem.vue?vue&type=script&lang=js"
export * from "./orderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ef89c",
  null
  
)

export default component.exports